import { Page, View, Image, Text } from '@react-pdf/renderer';
import { styles } from './styles';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { getImageSrc } from '@utils/fn';
import { eventTimeFormat } from '@utils/time';
import { useTranslation } from 'react-i18next';


export interface TitlePageProps {
  event: PublicEventDetailsResponse;
  footer: JSX.Element;
} 

const TitlePage = ({ event, footer }: TitlePageProps) => {
  const { t } = useTranslation();
  const imageUrls = [
    'https://media.we-conect.com/images/pdf/partnerprospectus/title_1.png',
    'https://media.we-conect.com/images/pdf/partnerprospectus/title_3.png',
    'https://media.we-conect.com/images/pdf/partnerprospectus/title_5.png',
    'https://media.we-conect.com/images/pdf/partnerprospectus/title_2.png',
    'https://media.we-conect.com/images/pdf/partnerprospectus/title_4.png',
    'https://media.we-conect.com/images/pdf/partnerprospectus/title_6.png',
  ];

  return (
    <Page
      size="A4" orientation="landscape"
      style={{ ...styles.page, overflow: 'hidden' }}
    >
      <View style={styles.leftColumn}>
       
        <View style={{ ...styles.imageColumnWrapper, top: -90, left: 0 }}>
          {imageUrls.slice(0, 3).map((url, idx) => (
            <View key={`left-1-${idx}`} style={styles.imageClip}>
              <Image src={url} style={styles.image} />
            </View>
          ))}
        </View>

      
        <View style={{ ...styles.imageColumnWrapper, top: -50, left: 220 }}>
          {imageUrls.slice(3, 6).map((url, idx) => (
            <View key={`left-2-${idx}`} style={styles.imageClip}>
              <Image src={url} style={styles.image} />
            </View>
          ))}
        </View>
      </View>

      <View style={styles.rightColumn}>
        <Image
          src={getImageSrc(event?.images?.logo)}
          style={styles.eventImage}
        />

        <View style={styles.textWrapper}>
          <Text style={styles.title}>{event?.description || ''}</Text>
          <Text style={styles.subtitle}>
            {eventTimeFormat(
              event?.start_date,
              event?.end_date,
              event?.language
            )}
            {' | '}
            {event?.location?.name ?? ''}, {event?.location?.marker?.city ?? ''}
            , {t(`countries.${event?.location?.marker?.country ?? ''}`)}
          </Text>
        </View>

        <View style={{ width: '100%', height: '100%', position: 'relative' }}>{footer} </View>
      </View>
    </Page>
  );
};

export default TitlePage;
